/**
 * @fileoverview GET handler for the "/generative_ai/agents/standards_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsStandardsSettings } from "./constants";
import type { GenerativeAiAgentsStandardsSettingsResult } from "./types";
import { isGenerativeAiAgentsStandardsSettingsResult } from "./validators";

export const getGenerativeAiAgentsStandardsSettings = reactQueryFetcherAdapter(
  generativeAiAgentsStandardsSettings,
  (signal: AbortSignal): Promise<GenerativeAiAgentsStandardsSettingsResult> => {
    return fetch(generativeAiAgentsStandardsSettings, "GET", {}, { signal });
  },
  isGenerativeAiAgentsStandardsSettingsResult
);
